import InstagramMode from './InstagramMode';
export default InstagramMode;
